import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';
import dayjs from 'dayjs';

const API_URL = config.API_URL;


const getDashboardData = (startDate, endDate,month,year,graph_month,graph_year) => {
    return axios.get(API_URL + '/dashboard', {
        headers: authHeader(),
        params: {
            start_date: dayjs(startDate).format('DD-MM-YYYY'),
            end_date: dayjs(endDate).format('DD-MM-YYYY'),
            month: month,
            year: year,
            graph_month: graph_month,
            graph_year: graph_year
        }
    });
};

const dashboardService = {
    getDashboardData,
};

export default dashboardService;
